import logo200Image from '../assets/img/logo/logo_2.png'
import React from 'react'
import { Button, Form, FormGroup, Input, Label, Row, Col, ModalBody, ModalFooter, ModalHeader, FormFeedback } from 'reactstrap'
import Typography from '../components/Typography'
import axios from '../utils/posAxios'
import { MdCameraAlt, MdFace, MdDone, MdClear } from 'react-icons/md'
import Avatar from '../components/Avatar'
import userPlaceholder from '../assets/img/users/profile.jpg'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { getTax } from '../utils/dropdownlist'
import update from 'immutability-helper'

class PosProductConditionForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isEdit: false,
      id: '',
      store_id: '',
      product_id: '',
      condition_type: '',
      start_date: '',
      end_date: '',
      params: '',
      condition_list: ['Available', 'MaxQuantity', 'MinQuantity', 'Available Days'],
      paramsInvalid:false,
      paramsInvalidText:''
    }
  }

  componentDidMount() {
    const data = this.props.data
    if (this.props.data.isEdit) {
      let id = this.props.data.selectedId
      const product_condition = this.props.data.product_condition.find(e => e.id === id)
      this.setState({
        isEdit: true,
        id: id,
        store_id: data.store_id,
        product_id: data.product_id,
        condition_type: product_condition.condition_type,
        start_date: product_condition.start_date,
        end_date: product_condition.end_date,
        params: product_condition.params,
      })
    } else {
      let condition_list = []
      for (let i of data.product_condition) {
        condition_list.push(i.condition_type)
      }

      let filter_condition_list = this.state.condition_list.filter(value => !condition_list.includes(value))

      this.setState({
        store_id: data.store_id,
        product_id: data.product_id,
        condition_list: filter_condition_list,
      })
    }
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
      paramsInvalid:false,
      paramsInvalidText:''
    })
  }

  //   priceChangeHandler = event => {
  //     const { name, value } = event.target;
  //     this.setState({
  //       price_data: update(this.state.price_data, {
  //         0: { [name]: { $set: value } },
  //       }),
  //     });
  //   };
  validateQuantity = (value) =>{
    const intValue = parseInt(value, 10);
    return intValue >= 1 && intValue <= 1000;
  }

  validateAvailableDays = (days) => {
    if (!days) return false;
    const validDays = ["Mon", "Tues", "Wed", "Thurs", "Fri", "Sat", "Sun"];
    const inputDays = days.split(";");
  
    return inputDays.every(day => validDays.includes(day));
  };

  validateConditionParams = (condition, params) => {
    if(condition == 'Available Days'){
      if(params == ""){
        this.setState({paramsInvalid:true, paramsInvalidText:'params cannot be empty if condition set to Available Days'});
        return false;
      }else{
        //console.log(this.validateAvailableDays(this.state.params));
        if(this.validateAvailableDays(params)){
          return true;
        }else{
          this.setState({paramsInvalid:true, paramsInvalidText:'Available Days only accept value like : Mon;Tues'});
          return false;
        }
      }
    }else if(condition == 'MaxQuantity' || condition =='MinQuantity'){
      if(params == ""){
        this.setState({paramsInvalid:true, paramsInvalidText:'params need value between 1 to 1000'});
        return false;
      }else{
        if(this.validateQuantity(params)){
          return true;
        }else{
          this.setState({paramsInvalid:true, paramsInvalidText:'params need value between 1 to 1000'});
          return false;
        }
      }
    }
    else{
      this.setState({paramsInvalid:false, paramsInvalidText:''});
      return true;
    }
  }

  handleSubmit = event => {
    event.preventDefault()
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL
    
    //console.log(this.validateConditionParams(this.state.condition_type, this.state.params));

    if(this.validateConditionParams(this.state.condition_type, this.state.params)){
      if (this.state.isEdit) {
        this.update(user, url)
      } else {
        this.add(user, url)
      }
    }
  }

  update(user, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      condition_id: this.state.id,
      condition_type: this.state.condition_type,
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      params: this.state.params,
      update_by: user.email,
    }
    axios
      .post(url + ':3002/v1/product/store/detail/condition/update', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(<MdDone />, 'Product Condition updated successfully.', 'success', false)
      })
      .catch(error => {
        alert(error)
      })
  }

  add(user, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      product_id: this.state.product_id,
      condition_type: this.state.condition_type,
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      params: this.state.params,
      created_by: user.email,
    }
    axios
      .post(url + ':3002/v1/product/store/detail/condition/add', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(<MdDone />, 'Product Condition added successfully.', 'success', false)
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>Product Condition Details</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label>Condition Type</Label>
                <Input type="select" name="condition_type" value={this.state.condition_type} onChange={this.changeHandler} disabled={this.state.isEdit} required>
                  <option></option>
                  {this.state.condition_list.map((item, index) => {
                    return (
                      <option key={item + index} value={item}>
                        {item}
                      </option>
                    )
                  })}
                </Input>
              </FormGroup>
              <FormGroup>
                <Label>Start Date</Label>
                <Input type="date" name="start_date" value={this.state.start_date} onChange={this.changeHandler} required />
              </FormGroup>

              <FormGroup>
                <Label>End Date</Label>
                <Input type="date" name="end_date" value={this.state.end_date} onChange={this.changeHandler} required />
              </FormGroup>
              <FormGroup>
                <Label>Params</Label>
                <Input type="text" name="params" value={this.state.params} onChange={this.changeHandler} invalid={this.state.paramsInvalid}/>
                <FormFeedback>{this.state.paramsInvalidText}</FormFeedback>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button className="theme-button theme-button-secondary" onClick={this.props.onToggleModal()}>
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    )
  }
}

export const STATE_ADD = 'ADD'
export const STATE_EDIT = 'EDIT'
export default PosProductConditionForm
